<template>
  <div class="slideshow-wrapper">
    <!-- Slideshow Container -->
    <div class="slideshow-container">
      <div v-for="(image, index) in images" :key="index" class="slide-item fade">
        <img :src="image.src" :alt="t(image.caption)" class="slide-image" />
        <div class="slide-overlay">
          <div class="caption mb-16">{{ t(image.caption) }}</div>
        </div>
      </div>

      <!-- Navigation Arrows -->
      <button class="nav-button prev" @click="prevSlide">
        <svg class="nav-icon" viewBox="0 0 24 24">
          <path d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button class="nav-button next" @click="nextSlide">
        <svg class="nav-icon" viewBox="0 0 24 24">
          <path d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>

    <!-- Dots Navigation -->
    <div class="dots-container">
      <span 
        v-for="(_, index) in images" 
        :key="'dot-' + index" 
        class="dot"
        :class="{ active: currentSlide === index }"
        @click="goToSlide(index)"
      ></span>
    </div>
  </div>
</template>
  <script setup> 
  import { onMounted, ref, onUnmounted } from 'vue'
  import { useI18n } from 'vue-i18n' // Import useI18n 
  
  const { t } = useI18n() // Destructure t (translation function) 
  
  const images = [
    { src: '/img/slide-c.png', caption: t('slideshow.caption1') },
    { src: '/img/slide-b.png', caption: t('slideshow.caption1') },
    // { src: '/img/slide-c.png', caption: t('slideshow.caption1') },
  ]
  
  const currentSlide = ref(0)
  let slideInterval = null
  
  const showSlide = (index) => {
    const slides = document.getElementsByClassName('slide-item')
    if (!slides.length) return
  
    for (let i = 0; i < slides.length; i++) {
      slides[i].style.display = 'none'
    }
    slides[index].style.display = 'block'
  }
  
  const nextSlide = () => {
    currentSlide.value = (currentSlide.value + 1) % images.length
    showSlide(currentSlide.value)
  }
  
  const prevSlide = () => {
    currentSlide.value = currentSlide.value === 0 ? images.length - 1 : currentSlide.value - 1
    showSlide(currentSlide.value)
  }
  
  const goToSlide = (index) => {
    currentSlide.value = index
    showSlide(currentSlide.value)
  }
  
  onMounted(() => {
    showSlide(currentSlide.value)
    slideInterval = setInterval(nextSlide, 5000)
  })
  
  onUnmounted(() => {
    if (slideInterval) clearInterval(slideInterval)
  })
  </script>
  <style scoped>
  .slideshow-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #000;
    overflow: hidden;
  }
  
  .slideshow-container {
    position: relative;
    width: 100%;
    height: 100%;
  }
  
  .slide-item {
    display: none;
    width: 100%;
    height: 100%;
    position: relative;
  }
  
  .slide-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  
  .slide-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(transparent, rgba(0,0,0,0.7));
    padding: 2rem;
  }
  
  .caption {
    color: white;
    font-size: 1.5rem;
    font-weight: 500;
    text-align: center;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
  }
  
  .nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0,0,0,0.5);
    border: none;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  }
  
  .nav-button:hover {
    background: rgba(0,0,0,0.8);
  }
  
  .prev {
    left: 1rem;
  }
  
  .next {
    right: 1rem;
  }
  
  .nav-icon {
    width: 1.5rem;
    height: 1.5rem;
    stroke: white;
    stroke-width: 2;
    fill: none;
  }
  
  .dots-container {
    position: absolute;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    display: flex;
    gap: 0.5rem;
  }
  
  .dot {
    width: 0.75rem;
    height: 0.75rem;
    background-color: rgba(255,255,255,0.5);
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .dot:hover {
    background-color: rgba(255,255,255,0.8);
  }
  
  .dot.active {
    background-color: white;
    transform: scale(1.2);
  }
  
  .fade {
    animation: fadeEffect 0.8s ease-in-out;
  }
  
  @keyframes fadeEffect {
    from {
      opacity: 0.4;
      transform: scale(1.02);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
    
  /* Responsive Design */
  @media (max-width: 768px) {
    .nav-button {
      width: 2.5rem;
      height: 2.5rem;
    }
  
    .nav-icon {
      width: 1.2rem;
      height: 1.2rem;
    }
  
    .caption {
      font-size: 1.2rem;
      padding: 1rem;
    }
  
    .dot {
      width: 0.6rem;
      height: 0.6rem;
    }
  }
  
  @media (max-width: 480px) {
    .caption {
      font-size: 1rem;
    }
  }
  </style>